/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useMemo } from "react";
import { ExtendedPaginationBox } from "@nordcloud/gnui";
import { useQueryState } from "~/hooks";

type Props = {
  count: number;
  small?: boolean;
};

export type PaginationState = {
  page: number;
  limit: number;
};

export function Pagination({ count, small }: Props) {
  const { state, set, updateQueryState } = useQueryState<PaginationState>();
  const { page, limit } = state;

  const startByPage = (currentPage: number, pageLimit: number) =>
    currentPage / pageLimit;

  const startByLimit = (pageLimit: number) => {
    return pageLimit;
  };

  const startFrom = (currentPage: number, pageLimit: number) =>
    currentPage * pageLimit;

  const isVisible = useMemo(() => count > 0, [count]);

  return isVisible ? (
    <ExtendedPaginationBox
      small={small}
      count={count}
      from={startFrom(page, limit)}
      size={limit}
      setPage={(newPage) => set("page")(startByPage(newPage, limit))}
      setSize={(newLimit) => {
        updateQueryState({
          limit: startByLimit(newLimit),
          page: 0,
        });
      }}
    />
  ) : null;
}
